// This browser as a device of its own (STAGE_5 5.0): an id made up once and kept, so
// the server keeps one session per device and "sign out" ends only this one. The
// tablet's id is also what the device dictionary binds to a vehicle (STAGE_5 5.2).

const DEVICE_KEY = 'sos.deviceId';

let fallback: string | null = null;

function newId(): string {
  return crypto.randomUUID();
}

/** The id of this browser; the same one across reloads and sign-ins. */
export function deviceId(): string {
  try {
    const stored = window.localStorage.getItem(DEVICE_KEY);
    if (stored) return stored;
    const made = newId();
    window.localStorage.setItem(DEVICE_KEY, made);
    return made;
  } catch {
    // No storage (a locked-down browser): one id for as long as the page lives.
    fallback ??= newId();
    return fallback;
  }
}

const BROWSERS: readonly [RegExp, string][] = [
  [/Edg\//, 'Edge'],
  [/OPR\//, 'Opera'],
  [/YaBrowser\//, 'Yandex'],
  [/Firefox\//, 'Firefox'],
  [/Chrome\//, 'Chrome'],
  [/Safari\//, 'Safari'],
];
const SYSTEMS: readonly [RegExp, string][] = [
  [/Android/, 'Android'],
  [/iPhone|iPad/, 'iOS'],
  [/Windows/, 'Windows'],
  [/Mac OS X/, 'macOS'],
  [/Linux/, 'Linux'],
];

/** "Chrome, Android": enough to tell the tablet from the desk PC in the sessions list. */
export function deviceLabel(userAgent: string = navigator.userAgent): string {
  const browser = BROWSERS.find(([pattern]) => pattern.test(userAgent))?.[1];
  const system = SYSTEMS.find(([pattern]) => pattern.test(userAgent))?.[1];
  return [browser, system].filter(Boolean).join(', ') || userAgent.slice(0, 128);
}
